export default "__VITE_ASSET__C9AGTL2Y__"